import axios from 'axios';
import { apiClient } from './apiClient';
import { Person } from '../types';
import { ApiError } from '../error/error';




//Λιστα όλων των Person
export const getPersonsAllList = async () => {
  try {
    const response = await apiClient.get(`api/admin/persons`);

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.error || 'Failed to get all persons', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }
};


//Πληροφορίες για ena Person
export const getPersonsSingle = async (id: number) => {
  try {
    const response = await apiClient.get(`api/admin/persons/${id}`);

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.error || 'Failed to get person', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }

};
export const getPersonsSingleEdit = async (id: number) => {
  try {
    const response = await apiClient.get(`api/admin/persons/${id}/edit`);

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.error || 'Failed', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }

};

//ADD Οντοτητας
export const addPerson = async ( data:any) => {
  try {
    const response = await apiClient.post(`api/admin/persons`, data );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.error || 'Failed to add person', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }
};

//UPDATE Οντοτητας
export const updatePerson = async (id: number, data:any) => {
  try {
    const response = await apiClient.put(`api/admin/persons/${id}`, data );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message ||error.response.data.error || 'Failed to update person', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }
};

//Delete PERSON
/*
    "data": {
        "message": "Person and related assigns soft-deleted successfully"
    },
    "status": 200,
*/
export const deletePerson = async (id: number) => {
  try {
    const response = await apiClient.delete(`api/admin/persons/${id}`);

    return response;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message ||error.response.data.error || 'Failed to delete person', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }
  
};

////////

//ASING ONTOTI POSITION TO PERSON
//οπου ΙD το person ID
/*{
    "person_id": 3,
    "ontoti_id": 31,
    "position_id": 2
}*/
export const addAssingPosition = async (data:any) => {
  try {
    //const response = await apiClient.post(`api/admin/persons/${id}/ontoti-position`, data );
    const response = await apiClient.post(`api/admin/relation/assign`, data );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message || 'Failed to assign possition', error.response.status);
    }
    throw new Error('An unknown error occurred');
  
  }
};
// DELETE ONTOTI POSITION FROM PERSON
//οπου ΙD το pivod_id
export const deleteAssingPosition = async (id: number) => {
  try {
    //const response = await apiClient.delete(`api/admin/persons/${id}/remove-ontoti-position` );
    const response = await apiClient.delete(`api/admin/ontoti-position/${id}` );
   

    return response.data;
   
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message || 'Failed to delete possition', error.response.status);
    }
    throw new Error('An unknown error occurred');
  
  }
};

export const updateAssingPosition = async (id: number, data:any) => {
  try {
   // const response = await apiClient.put(`api/admin/persons/${id}/update-ontoti-position`, data );

   
    const response = await apiClient.put(`api/admin/ontoti-position/${id}`, data );

   
    return response.data;
   
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message || 'Failed to update possition', error.response.status);
    }
    throw new Error('An unknown error occurred');
  
  }
};